import type { FaireProductEntity } from "../../entity_types/product";

export const p_a39uqyc2ws: FaireProductEntity = {
  token: "p_a39uqyc2ws",
  type: "product",
  name: "Spring Candy Color Matte Duckbill Hair Clips",
  brandToken: "b_2fgt3byexw",
  brandName: "TheDivaSoap",
  imageUrl:
    "https://cdn.faire.com/fastly/8ac62c724499a3799f822a7f141c494780c7fc0fa9e5b1fafe448c39e9fc6c47.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5ab3826899d6986d861f37a1ad4e4c7157b01a58815f3bb383acb7e75908a3d5.jpeg",
    "https://cdn.faire.com/fastly/9f740b7f3c36d32bd46158a40cfacbe0179e172ffa132352f0e80243ebb9009e.jpeg",
    "https://cdn.faire.com/fastly/130d9987523e50e12bf12b34c9cdbf4a7518c35b93942e6adccddd64183e887b.jpeg",
    "https://cdn.faire.com/fastly/70646ac6c29bd5e826f758e053cf69255c7b3682d71c3c2c1e66083c4288d39e.jpeg",
    "https://cdn.faire.com/fastly/2405a4d41b8dc48336ab0b663b5c26bae92d6f2882a480c6b0e563842a467b53.jpeg",
    "https://cdn.faire.com/fastly/32155f0c777157f55f298ce67d6ce08560a4fc30f1802b07aa41ca414ee2768c.jpeg",
    "https://cdn.faire.com/fastly/769ec977bb03fa57299652febf78d71ac1044e45c1fc90478769218c52a763c6.jpeg",
  ],
  priceDollars: 0.79,
  description:
    "Colorful barrettes for girls and women to section/hold hair tight, hair clips of different colors can be matched with different hairstyles and clothes.\n\nMade from resin\nSize: 1.57'' L x 0.7'' W",
  tags: [],
  msrpDollars: 1.58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:08.655Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
